import request from "@assets/js/axios";
const { instance: $axios } = request;
class Travel {
    constructor() { }


    //   获取旅游首页相关信息
    getHomePageInfo() {
        return $axios.get('/apiv1/goods/tours');
    }

}

export default new Travel();